var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button } from "semantic-ui-react";
var ChangeVariantIsControlModal = /** @class */ (function (_super) {
    __extends(ChangeVariantIsControlModal, _super);
    function ChangeVariantIsControlModal(props) {
        var _this = _super.call(this, props) || this;
        _this.submit = function () {
            _this.props.postRequest("/admin/catalog/rna/organisms/id/" + encodeURIComponent(_this.props.orgId.toString()) +
                ("/probe-set-families/id/" + encodeURIComponent(_this.props.psfId.toString())) +
                ("/variants/id/" + encodeURIComponent(_this.props.variantId.toString()) + "/is-control"), { isControl: _this.props.isControl });
        };
        return _this;
    }
    ChangeVariantIsControlModal.prototype.render = function () {
        var label = this.props.isControl ? 'control' : 'not a control';
        return React.createElement(React.Fragment, null,
            React.createElement("p", null,
                "Are you sure you want to mark variant ",
                this.props.variantId,
                " as ",
                React.createElement("strong", null, label),
                "?"),
            React.createElement(Button, { disabled: this.props.state.loading || this.props.state.success, icon: this.props.isControl ? 'check' : 'remove', label: "Mark as " + label, labelPosition: 'left', onClick: this.submit, positive: this.props.isControl, negative: !this.props.isControl }));
    };
    return ChangeVariantIsControlModal;
}(React.PureComponent));
export default ChangeVariantIsControlModal;
//# sourceMappingURL=ChangeVariantIsControlModal.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/ChangeVariantIsControlModal.js
// module id = 1461
// module chunks = 0